import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigKey, ImageClient, InsertImageModel, QResult, QueovalDate } from '../models';
import { CoreService, HttpService, QueovalDateService } from '../services';
import { ToastService } from '../toast';
import { lastIndexOf } from 'lodash';

@Component({
  selector: 'q-insert-image',
  templateUrl: './insert-image.component.html',
  styleUrls: ['./insert-image.component.css']
})

export class InsertImageComponent implements OnInit {

  constructor(
    protected http: HttpService,
    private httpClient: HttpClient,
    public indParam: CoreService,
    private qDateService: QueovalDateService,
    private modalService: NgbModal,
    protected toastservice: ToastService
  ) { }


  /**
  * Suppression optionnelle
  */
  @Input('CanDelete') set SetDelete(value: boolean) {
    this.canDelete = value;
  }


  // #region upload new image

  /**
   * Affichage ou non de l'upload d'une image
   */
  public showUpload: boolean;

  /**
   * Fichier de la nouvelle image
   */
  public fileImg: any;

  public fileInputValue: any;

  /**
   * Nom de la nouvelle image
   */
  public newImgName: string;

  /**
   * Booleen pour indiquer que l'image est en cours d'upload
   */
  public isUploading: boolean;

  /**
   * Booleen pour indiquer le chargement d'images supplémentaires
   */
  public isLoadingMore: boolean;

  // #endregion

  /**
   * Liste des images à afficher
   */
  public listImages: Array<ImageClient>;

  /**
  * Liste de toutes les images
  */
  public listAllImages: Array<ImageClient>;

  /**
   * Filtre
   */
  public filter: string;

  /**
   * Booléen pour indiquer qu'il y a d'autres images à afficher
   */
  public hasMoreImages: boolean;

  /**
   * Booléen pour savoir si on peut supprimer les images
   */
  public canDelete: boolean = true;

  /**
   * Url de l'image à copier dans le presse papier
   */
  public urlToCopy: string;

  /**
   * Image sélectionnée (pour la suppression par exemple)
   */
  public selectedImage: ImageClient;

  /**
   * Boooléen pour indiquer que l'image est en cours
   */
  public isDeleting: boolean;

  /* modal de suppression */
  @ViewChild('ModalDeleteValidation') ModalDeleteValidation: TemplateRef<HTMLTemplateElement>;


  ngOnInit(): void {
    this.newImgName = '';
    this.isUploading = false;
    this.selectedImage = new ImageClient();

    // Récupération de la liste des images
    this.getListImg();
  }

  /**
 * Clic sur le bouton pour afficher / masque l'upload d'une nouvelle image
 */
  public ShowUploadNewImage(): void {
    this.showUpload = !this.showUpload;
  }

  // Sélection du fichier à uploader
  public onSelectChange(e: any): void {
    this.fileImg = e.target.files[0];
    this.newImgName = !(e.target.files[0]) ? '' : e.target.files[0].name;
  }

  /**
   * Upload d'une image
   */
  public ValidUpload(): void {
    if (!this.isUploading) {
      if (this.fileImg.size > 0) {
        // Taille maximale : 2Mo
        if (this.fileImg.size < 2000000) {
          this.isUploading = true;

          const ext: string = this.newImgName.split('.')[this.newImgName.split('.').length - 1];

          // 1) we pass to the webstreamAPI the parameter 'saveas' with a unique key
          // 2) the webstreamAPI rename the file with a time stamp stock the file in the proper folder
          //  const timestamp: string = `${Math.floor(Math.random() * Math.floor(999))}${Math.floor(Date.now() / 1000)}`;
          const formData: FormData = new FormData();
          formData.append('file', this.fileImg, this.newImgName);
          formData.append('mode', 'FILEINPROD');
          // formData.append('timestampname', `${timestamp}.${ext}`);
          formData.append('name', this.newImgName);
          formData.append('token', this.indParam.AppParams.token);

          const streamHttp: string = this.indParam.getConfigKey(ConfigKey.STREAM_HTTP);

          const fileName = this.newImgName;

          let headers: any = { headers: { Queoval: this.indParam.AppParams.token } };

          //const call1: Observable<StreamExtranetModel> = this.http.get<StreamExtranetModel>(`${streamHttp}api/Stream/BO/PREDATA/0`, headers);
          this.httpClient.post(`${streamHttp}api/StreamUpload`, formData, { responseType: 'arraybuffer' as 'arraybuffer' }).subscribe((results: any): void => {
            // const fileName: string | null = `${timestamp}.${ext}`;
            const httpPath: string | null = `${this.indParam.getConfigKey(ConfigKey.IMGHTTP)}/Images/${this.indParam.AppParams.dbname}/${fileName}`;

            // chargement de l'image chargée pour l'insérer à la liste (en 1ère)
            const newImg: ImageClient = new ImageClient();
            newImg.Name = fileName;
            newImg.Extension = ext;
            newImg.Path = httpPath;
            const dateNow = new Date();
            newImg.UpdateDate = this.qDateService.FromDate(dateNow);
            this.listImages.unshift(newImg);

            this.toastservice.showSuccessToast('Image ajoutée avec succès');

            // copie de l'image ajoutée
            this.copyImg(newImg);

            this.isUploading = false;

          }, (error: Error): void => {
            console.error(JSON.stringify(error));
            this.isUploading = false;
          });
        }
        else {
          this.toastservice.showAlertToast('Fichier non chargé : Le fichier ne doit pas dépasser 2Mo');
        }
      }
      else {
        this.toastservice.showWarningToast('Sélection du fichier obligatoire');
      }
      this.fileInputValue = null;
      this.fileImg = null;
      this.newImgName = "";
    }

  }

  /**
   * Copie de l'image
   */
  public copyImg(image: ImageClient): void {
    this.urlToCopy = image.Path;
    this.copyField();
  }

  /**
   * Affectation de l'image à supprimer
   */
  public AffecteImageToDelete(image: ImageClient): void {
    this.selectedImage = image;
  }

  /** Ouvrir une modal , la taille dépend du paramètre xl (vrai par default => modal taille q-xxl)
 * 
 * @param Modal la modal qui doit être ouverte
 * @param xl si oui la modal est grande, sinon elle est de taille réduite
 */
  public open(Modal: any, xl: boolean = true) {
    if (xl) {
      this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' });
    } else {
      this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
    }
  }

  /**
   * Suppression d'une image
   */
  public deleteImage(): void {
    if (!this.isDeleting) {
      this.isDeleting = true;
      this.http.postHttp<QResult<ImageClient>>(`${this.indParam.AppParams.apiUrl}api/AdminImage/DELETE_IMAGE`, this.selectedImage).subscribe(
        (result: QResult<ImageClient>) => {
          if (!result.HasError && !result.HasAlert) {
            // suppression de l'image dans les listes
            this.listAllImages.splice(this.listAllImages.indexOf(this.selectedImage), 1);
            this.listImages.splice(this.listImages.indexOf(this.selectedImage), 1);
            this.selectedImage = new ImageClient();
            this.modalService.dismissAll();
            this.toastservice.showSuccessToast('Image supprimée');
          }
          this.isDeleting = false;
        });
    }

  }

  /**
   * Affichage de 20 images supplémentaires dans la liste
   */
  public showMoreImages(): void {
    this.isLoadingMore = true;
    // s'il y a un filtre
    if (this.filter && this.filter != '') {
      let count = 0;
      this.hasMoreImages = false;
      for (var i = 0; i < this.listAllImages.length; i++) {
        if (this.listAllImages[i].Name.toUpperCase().includes(this.filter.toUpperCase())) {
          if (!this.listImages.includes(this.listAllImages[i])) {
            if (count < 20) {
              this.listImages.push(this.listAllImages[i]);
              count++;
            }
            else {
              this.hasMoreImages = true;
            }
          }

        }

      }
    }
    else {
      // sans filtre -> affichage des 20 suvantes
      const lastIndex: number = this.listImages.length;
      for (var i = lastIndex; i < lastIndex + 20; i++) {
        if (i < this.listAllImages.length) {
          this.listImages.push(this.listAllImages[i]);
        }
        else {
          this.hasMoreImages = false;
        }
      }
    }


    this.isLoadingMore = false;
  }


  /**
   * Filtre sur la liste des images
   */
  public filterImage(): void {
    this.listImages = [];
    // filtre en affichant une liste de 20 éléments max
    this.hasMoreImages = false;
    for (var i = 0; i < this.listAllImages.length; i++) {
      if (this.listAllImages[i].Name.toUpperCase().includes(this.filter.toUpperCase())) {
        if (this.listImages.length < 20) {
          this.listImages.push(this.listAllImages[i]);
        }
        else {
          this.hasMoreImages = true;
        }
      }

    }


  }

  //#region private function

  /**
   * Récupération de la liste des images du client
   */
  private getListImg(): void {

    this.listAllImages = [];
    this.listImages = [];
    this.http.getHttp<QResult<InsertImageModel>>(`${this.indParam.AppParams.apiUrl}api/AdminImage/GET_LIST_IMAGE/0`).subscribe(
      (data: QResult<InsertImageModel>) => {
        if (!data.HasError) {
          this.listAllImages = data.Value.ListImage;
          // Par défaut affichage des 20 premières images
          this.hasMoreImages = true;
          for (var i = 0; i < 20; i++) {
            if (i < this.listAllImages.length) {
              this.listImages.push(this.listAllImages[i]);
            }
            else {
              this.hasMoreImages = false;
            }

          }
        }
      });
  }

  /**
   * Copie dans presse papier
   */
  private copyField(): void {
    const $temp: any = $('<input>');
    $('body').append($temp);
    $temp.val(this.urlToCopy).select();
    document.execCommand('copy');
    $temp.val(document.execCommand('copy'));
    // scope.unionField = document.execCommand('copy');
    $temp.remove();
    this.toastservice.showInfoToast(`Lien de l'image copié`);
  }

  //#endregion

}
